import { render, staticRenderFns } from "./SingleSignOnProviderList.vue?vue&type=template&id=460f0464&"
import script from "./SingleSignOnProviderList.vue?vue&type=script&lang=ts&"
export * from "./SingleSignOnProviderList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports